import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

import { ds } from '@/components/lib/design.system';

const SvgComponent = props => (
    <Svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}>
        <Path
            stroke={ds.colorValue.icon.primary}
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="m13 7.5 4.5 4.5m0 0L13 16.5m4.5-4.5h-11"
        />
    </Svg>
);
export { SvgComponent as RightArrow };
